import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFossilscmComponent } from './simple-icons-fossilscm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFossilscmComponent ],
    exports:      [ SimpleIconsFossilscmComponent ],
    bootstrap:    []
})
export class SimpleIconsFossilscmModule {}
